import { isObject } from '.';

export const getNestedValue = (obj: unknown, path: string): unknown => {
    if (!path || !isObject(obj)) return undefined;

    return path.split('.').reduce((acc: unknown, part: string) => {
        if (isObject(acc)) {
            return acc[part];
        }
        return undefined;
    }, obj);
};
